import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Typography } from '@mui/material';
import { ActionSet } from 'models/action-set';
import { Action } from 'models/action';
import BrowseActions from './browse-actions/browse-actions.component';
import SearchAction from './search-action/search-action.component';

type ActionSource = 'search' | 'browse';

type SelectActionProps = {
    actionSet: ActionSet;
    onActionSelected?: (action: Action, categoryId: string, subCategoryId: string) => void;
    onActionCleared?: () => void;
};
const SelectAction: FC<SelectActionProps> = ({ actionSet, onActionSelected, onActionCleared }) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    const [searchTouched, setSearchTouched] = useState(false);
    const [browseTouched, setBrowseTouched] = useState(false);
    const [selectedActionSource, setSelectedActionSource] = useState<ActionSource | null>(null);

    const handleActionSelected =
        (source: ActionSource) => (action: Action, categoryId: string, subCategoryId: string) => {
            setSelectedActionSource(source);
            if (onActionSelected) {
                onActionSelected(action, categoryId, subCategoryId);
            }
        };

    // Clearing one path must not drop an action that was chosen through the other
    const handleActionCleared = (source: ActionSource) => () => {
        if (selectedActionSource !== source) {
            return;
        }
        setSelectedActionSource(null);
        if (onActionCleared) {
            onActionCleared();
        }
    };

    return (
        <>
            <Box sx={{ opacity: browseTouched ? 0.3 : 1 }}>
                <Box mb={2}>
                    <Typography variant="h3">{translate('orders:SEARCH_ACTION')}</Typography>
                </Box>
                <Box>
                    <SearchAction
                        actionSet={actionSet}
                        onActionSelected={handleActionSelected('search')}
                        onActionCleared={handleActionCleared('search')}
                        onTouched={() => {
                            setSearchTouched(true);
                            setBrowseTouched(false);
                        }}
                    />
                </Box>
            </Box>
            <Box my={4} sx={{ opacity: browseTouched || searchTouched ? 0.3 : 1 }}>
                <Divider>{translate('common:OR')}</Divider>
            </Box>
            <Box sx={{ opacity: searchTouched ? 0.3 : 1 }}>
                <Box mb={2}>
                    <Typography variant="h3">{translate('orders:FIND_ACTION_BY_CATEGORY')}</Typography>
                </Box>
                <Box>
                    <BrowseActions
                        onTouched={() => {
                            setBrowseTouched(true);
                            setSearchTouched(false);
                        }}
                        actionSet={actionSet}
                        onActionSelected={handleActionSelected('browse')}
                        onActionCleared={handleActionCleared('browse')}
                    />
                </Box>
            </Box>
        </>
    );
};

export default SelectAction;
